export default {
  nav: {
    home: 'Главная',
    services: 'Услуги',
    calculator: 'Калькулятор',
    work: 'Работы',
    faq: 'FAQ',
  },
  hero: {
    tagline: 'Telegram-боты под ключ',
    label: 'Агентство Telegram-ботов',
    title1: 'Telegram-бот',
    title2: 'за 7 дней',
    title3: 'под ключ',
    subtitle:
      'Продажи, поддержка, бронирование, рассылки — автоматизируем процессы, на которые уходит несколько часов в день. Срок и цена — в договоре до старта.',
    cta: 'Выбрать тип бота',
    stat1: 'Срок от',
    stat1Value: '2 дня',
    stat2: 'Поддержка',
    stat2Value: '30 дней',
    stat3: 'Цена от',
    stat3Value: '15 000 ₽',
  },
  services: {
    label: 'Каталог',
    title: 'Выберите тип бота',
    select: 'Выбрать',
    selected: 'Выбрано',
    complexity: 'Сложность',
    complexityLow: 'Простой',
    complexityMedium: 'Средний',
    complexityHigh: 'Сложный',
    bots: {
      'ai-support': {
        name: 'AI-поддержка',
        desc: 'Автоматические ответы на типовые запросы клиентов 24/7. Передаёт сложные кейсы оператору.',
        features: ['GPT-интеграция', 'Ответы 24/7', 'Несколько языков', 'Передача в CRM'],
      },
      ecommerce: {
        name: 'Магазин',
        desc: 'Каталог, корзина, приём оплат и отслеживание заказов прямо в Telegram.',
        features: ['Каталог', 'Корзина', 'Оплаты', 'Статусы заказов'],
      },
      subscription: {
        name: 'Подписки',
        desc: 'Закрытый канал/чат с тарифами, автопродлением и аналитикой.',
        features: ['Тарифы', 'Автопродление', 'Инвайт-ссылки', 'Аналитика'],
      },
      'lead-gen': {
        name: 'Лидогенерация',
        desc: 'Квалификация лидов через диалог, скоринг и передача в CRM.',
        features: ['Воронка', 'Интеграция CRM', 'Скоринг', 'Уведомления'],
      },
      trading: {
        name: 'Трейдинг-сигналы',
        desc: 'Уведомления о сигналах, отслеживание портфеля, графики.',
        features: ['Сигналы', 'Портфель', 'Алерты', 'Графики'],
      },
      booking: {
        name: 'Бронирование',
        desc: 'Календарь, напоминания, приём оплат, управление сотрудниками.',
        features: ['Календарь', 'Напоминания', 'Оплаты', 'Сотрудники'],
      },
      moderation: {
        name: 'Модерация',
        desc: 'Антиспам, CAPTCHA, приветствия, проверка правил, админ-панель.',
        features: ['Антиспам', 'CAPTCHA', 'Приветствия', 'Админ-инструменты'],
      },
      education: {
        name: 'Курсы',
        desc: 'Уроки, прогресс, тесты, сертификаты, управление учениками.',
        features: ['Уроки', 'Прогресс', 'Тесты', 'Сертификаты'],
      },
    },
  },
  info: {
    label: 'Как мы работаем',
    title: 'Что входит в проект',
    subtitle:
      'Прозрачные условия, которые мы фиксируем в договоре до старта работ.',
    carouselLabel: 'Преимущества агентства',
    dotsLabel: 'Выбор слайда',
    prevSlide: 'Предыдущий слайд',
    nextSlide: 'Следующий слайд',
    of: 'из',
    badge: {
      included: 'Включено',
      highlight: 'Важно',
    },
    slides: {
      contract: {
        title: 'Договор до оплаты',
        desc: 'Подписываем условия, фиксируем цену и сроки. Только после этого выставляем счёт.',
      },
      prototype: {
        title: 'Прототип на 2–3 день',
        desc: 'Рабочий бот с базовой логикой в течение 48–72 часов после согласования ТЗ.',
      },
      deploy: {
        title: 'Запуск за 1–2 недели',
        desc: 'От первого созвона до прод-деплоя — обычно 7–14 рабочих дней. Сложные интеграции — по графику.',
      },
      ai: {
        title: 'GPT-4o и Claude 3.5 Sonnet',
        desc: 'На выбор: OpenAI GPT-4o / 4o-mini или Anthropic Claude 3.5 Sonnet. Системные промпты под вашу нишу.',
      },
      crm: {
        title: 'Интеграции с CRM',
        desc: 'AmoCRM, Bitrix24, Google Sheets, webhooks. Лиды и заказы летят туда, где их ждут менеджеры.',
      },
      payments: {
        title: 'Платежи под РФ и мир',
        desc: 'Telegram Stars, СБП, карты РФ, Tribute для UE-карт. USDT/TON по запросу. Pre-checkout валидация.',
      },
      multilang: {
        title: 'Мультиязычность из коробки',
        desc: 'Авто-определение языка пользователя по Telegram-локали. RU, EN и любой дополнительный — по запросу.',
      },
      security: {
        title: 'AES-GCM и аудит-логи',
        desc: 'Шифрование чувствительных данных, HMAC-проверка webhook-ов, журнал всех действий пользователей и админов.',
      },
      hosting: {
        title: 'Хостинг 6 месяцев включён',
        desc: 'VPS, домен и SSL за наш счёт первые полгода. Дальше — 1 500 ₽/мес или миграция к вам с исходниками.',
      },
      support: {
        title: '30 дней правок после сдачи',
        desc: 'Любые корректировки и мелкие доработки в течение месяца без доплат. Дальше — по тарифу или self-host.',
      },
      sources: {
        title: 'Исходники у вас',
        desc: 'После финального платежа — полный код, документация, доступы. Без вендор-лока.',
      },
    },
  },
  calculator: {
    label: 'Калькулятор',
    title: 'Оценка стоимости',
    botType: 'Тип бота',
    complexity: 'Уровень сложности',
    basic: 'Базовый',
    standard: 'Стандартный',
    advanced: 'Продвинутый',
    features: 'Дополнительные функции',
    featuresList: {
      ai: 'AI-интеграция',
      payments: 'Приём оплат',
      dashboard: 'Админ-панель',
      crm: 'Интеграция с CRM',
      multilang: 'Несколько языков',
      analytics: 'Аналитика',
      api: 'API / Вебхуки',
      design: 'Кастомный дизайн',
    },
    expressDelivery: 'Экспресс-разработка (48 ч)',
    expressExtra: '+30%',
    priceLabel: 'Ориентировочная цена',
    delivery: 'Срок',
    days: 'рабочих дней',
    orderBtn: 'Оставить заявку',
    disclaimer:
      'Финальная цена и срок фиксируются в договоре после короткого созвона.',
  },
  portfolio: {
    label: 'Примеры',
    title: 'Типы проектов, которые мы делаем',
    projects: {
      crypto: {
        name: 'Трейдинг-сигналы',
        desc: 'Сигналы в реальном времени, портфель, графики.',
        category: 'Крипто',
      },
      shop: {
        name: 'E-commerce магазин',
        desc: 'Каталог, корзина, оплаты внутри Telegram.',
        category: 'E-commerce',
      },
      edu: {
        name: 'Платформа курсов',
        desc: 'Уроки, прогресс, тесты, сертификаты.',
        category: 'Образование',
      },
      med: {
        name: 'Запись к врачу',
        desc: 'Бронирование, напоминания, оплаты.',
        category: 'Медицина',
      },
      support: {
        name: 'AI-поддержка',
        desc: 'Автоответы 24/7 с эскалацией оператору.',
        category: 'Поддержка',
      },
      event: {
        name: 'Управление событиями',
        desc: 'Билеты, QR-чек-ин, рассылки участникам.',
        category: 'События',
      },
    },
    stats: { time: 'дней', users: 'пользователей' },
  },
  process: {
    label: 'Процесс',
    title: 'Как мы работаем',
    steps: {
      1: {
        title: 'День 0: обсуждаем',
        desc: '15-минутный созвон в Telegram. В тот же день — смета и техническое задание.',
      },
      2: {
        title: 'День 1–2: прототип',
        desc: 'Показываем рабочий прототип. Не понравилось — не платите дальше.',
      },
      3: {
        title: 'День 3–7: разработка',
        desc: 'Финальные функции, тесты, развёртывание на нашем сервере.',
      },
      4: {
        title: 'День 7+: поддержка',
        desc: '30 дней правок и багфиксов включено. Дальше — поддержка по подписке.',
      },
    },
  },
  faq: {
    label: 'FAQ',
    title: 'Частые вопросы',
    questions: [
      {
        q: 'Сколько занимает разработка?',
        a: 'Базовые боты — 2–5 рабочих дней. Стандартные — 5–10 дней. Сложные с AI и интеграциями — 10–21 день. Экспресс-разработка за 48 часов доступна с надбавкой 30%.',
      },
      {
        q: 'Что если результат не устроит?',
        a: 'Вы платите 50% после показа прототипа. Если прототип не понравился — оставшуюся часть не вносите, исходники прототипа остаются у вас.',
      },
      {
        q: 'Кто будет хостить бота?',
        a: 'Первые 6 месяцев — на нашем сервере бесплатно. Дальше — продлеваете у нас за 1 500 ₽/мес или переносим к вам.',
      },
      {
        q: 'А если бот сломается через месяц?',
        a: '30 дней после сдачи — все правки и баг-фиксы бесплатно. Дальше — поддержка от 5 000 ₽/мес или передаём исходники, и вы поддерживаете сами.',
      },
      {
        q: 'У меня нет техзадания. Что делать?',
        a: 'ТЗ пишем мы после 15-минутного созвона. Бесплатно, до подписания договора.',
      },
      {
        q: 'Какие способы оплаты?',
        a: 'Telegram Stars, банковский перевод, карты РФ (СБП), зарубежные карты через Stripe, USDT/TON. Стандартно: 50% после показа прототипа, 50% при сдаче.',
      },
      {
        q: 'А если Telegram забанит бота?',
        a: 'Делаем по официальному Bot API, в рамках правил Telegram. Если бан произойдёт не из-за вашего контента — поможем восстановить или сделать резервного бота.',
      },
      {
        q: 'Передаёте ли вы исходный код?',
        a: 'Да. После полной оплаты — весь код, документация, доступы. Стек: Node.js + MySQL, бот на Telegraf.',
      },
    ],
  },
  order: {
    title: 'Оставить заявку',
    description: 'Описание задачи',
    descPlaceholder: 'Опишите, что должен делать бот, кто целевая аудитория, есть ли референсы…',
    budget: 'Ориентировочный бюджет',
    budgets: ['До 25 000 ₽', '25 000 – 50 000 ₽', '50 000 – 100 000 ₽', '100 000 ₽ и выше', 'Не знаю'],
    submit: 'Отправить',
    creating: 'Отправляем…',
    success: 'Заявка отправлена',
    successMsg:
      'Менеджер свяжется в течение 24 часов в Telegram. Открыть бот можно из меню.',
    successCta: 'Понятно',
    error: 'Не удалось отправить. Попробуйте позже.',
    paymentTitle: 'Способ оплаты',
    paymentNote: 'Выбор оплаты не обязателен на этапе заявки.',
    paymentStars: 'Telegram Stars',
    paymentRuCard: 'Карта РФ',
    paymentIntlCard: 'Зарубежная карта',
    paymentCrypto: 'Крипто (USDT/TON)',
    paymentMethodNote: 'Финальный счёт пришлёт менеджер после согласования техзадания.',
    payNow: 'Оплатить',
    back: 'Назад',
    notInTelegram:
      'Откройте приложение через Telegram, чтобы оставить заявку. В обычном браузере отправка недоступна.',
    serviceLabel: 'Тип бота',
  },
  lang: { ru: 'RU', en: 'EN' },
  common: {
    openInTelegram: 'Открыть в Telegram',
    openBotInTelegram: 'Перейти к боту в Telegram',
    inBrowserHint:
      'Вы открыли сайт в браузере. Откройте бота в Telegram — там доступны оплата, заявки и автоматическая идентификация.',
    account: 'Личный кабинет',
    signIn: 'Войти',
  },
  auth: {
    backToHome: 'На главную',
    signIn: 'Вход через Telegram',
    signInHint:
      'Войдите через Telegram — мы используем стандартный Telegram Login Widget. Никаких паролей: подтверждаете на телефоне и попадаете в свой кабинет.',
    signInPrivacy:
      'Нажимая кнопку, вы соглашаетесь с политикой конфиденциальности. Мы получим только публичные данные вашего профиля (имя, username, фото).',
    logout: 'Выйти',
    loading: 'Загрузка…',
  },
  account: {
    loading: 'Загрузка…',
    goToCatalog: 'Перейти в каталог',
    tabs: {
      profile: 'Профиль',
      orders: 'Заявки',
      payments: 'Оплаты',
      messages: 'Диалоги',
    },
    summary: {
      orders: 'Всего заявок',
      active: 'В работе',
      completed: 'Готово',
      paid: 'Оплачено',
    },
    profile: {
      telegramData: 'Данные из Telegram',
      accountInfo: 'Информация об аккаунте',
      firstName: 'Имя',
      lastName: 'Фамилия',
      username: 'Username',
      telegramId: 'Telegram ID',
      registered: 'Зарегистрирован',
      lastLogin: 'Последний вход',
      title: 'Контактные данные',
      subtitle: 'Эти поля видны менеджеру при обработке заявки.',
      email: 'Email',
      phone: 'Телефон',
      notes: 'Заметки для менеджера',
      notesPlaceholder:
        'Можете оставить любую информацию: предпочитаемый канал связи, время для звонка, ссылки на референсы.',
      save: 'Сохранить',
      saving: 'Сохраняем…',
      saved: 'Сохранено',
    },
    orders: {
      empty: 'Заявок пока нет. Оставьте первую через калькулятор на главной.',
      orderNo: 'Заявка #{{id}}',
      paymentPending: 'оплата ожидается',
      price: 'Цена',
      budget: 'Бюджет',
      paymentMethod: 'Способ оплаты',
      payments: 'Оплата',
      viewPayments: 'Посмотреть платежи',
    },
    payments: {
      empty: 'Оплат пока не было.',
      orderRef: 'По заявке #{{id}}',
      txn: 'Идентификатор транзакции',
      viewOrder: 'Открыть заявку',
    },
    messages: {
      empty: 'Здесь будет история диалогов с ботом.',
    },
  },
} as const;
